import AssignLessonActionWithDateSelectionV2 from '../../../../../lessons/lessonactions/lesson-multi-selection-actions/AssignLessonActionWithDateSelectionV2';
import { useDomain } from '../../../../../../states/AppDomainProvider';
import { useTeacherCourses } from '../../../../context/TeacherCourseContextProvider';
import { useGetTopicDropdownList, useGetUnitDropdownList } from '../../../TeacherCourseSearchBarHooks';
import { useGetAssignedStudentCourses } from '../../../../../lessons/assigned-student-courses/AssignedStudentCoursesHooks';
import { useHandleTeacherCourseAssigment } from '../TeacherCourseLessonsHooks';
import ChurnZeroService from '../../../../../../services/ChurnZeroService';
import { CHURNZERO_CONSTANT } from '../../../../../../constants/ChurnZeroConstant';
import { filterUndefined } from '../../../../../../utils/FilterUndefinedObject';

const defaultProps = {
  lessons: [],
  selectedLessonIds: [],
  selectedDates: {},
};

export default function TeacherCourseAssignLessonsAction(p) {
  const {
    lessons,
    selectedLessonIds,
    selectedDates,
  } = { ...defaultProps, ...filterUndefined(p) };

  const { teacherCourseDomain, teacherCourseSearchCriteriaDomain } = useTeacherCourses();
  const { lessonCourses } = teacherCourseDomain.domainData;
  const { searchCriteria } = teacherCourseSearchCriteriaDomain.domainData;
  const { userDomain } = useDomain();
  const { user } = userDomain.domainData;

  const course = ((lessonCourses || []).find((l) => l.id === searchCriteria.courseId) || {}).name;

  const unitList = useGetUnitDropdownList(searchCriteria.courseId);
  const unit = (unitList.find((l) => l.id === searchCriteria.unitId) || {}).name;

  const topicList = useGetTopicDropdownList(searchCriteria.courseId, searchCriteria.unitId);
  const topic = (topicList.find((l) => l.id === searchCriteria.topicId) || {}).name;

  const tags = `${course}, ${unit}, ${topic}, Level ${searchCriteria.lessonLevel}`;

  const propsArg = useHandleTeacherCourseAssigment();

  const {
    getAssignedStudentData,
  } = useGetAssignedStudentCourses({
    onStartLoading: null,
    subjectId: propsArg.subjectId,
    onDataLoad: propsArg.onDataLoad,
    assignedStudentCourses: propsArg.assignedStudentCourses,
    filterCriteriaAssignedStudentCourses: propsArg.filterCriteriaAssignedStudentCourses,
  });

  ChurnZeroService.trackEvent(CHURNZERO_CONSTANT.USAGE, 'Assign Activity - Course', user);

  return (
    <AssignLessonActionWithDateSelectionV2
      lessons={lessons}
      selectedLessonIds={selectedLessonIds}
      showAddToMyList
      reloadDataFunc={async () => {
        getAssignedStudentData(selectedDates);
      }}
      tagNameForAutoSaving={[tags]}
      objectiveType='COURSES'
    />
  );
}
